// extracted by mini-css-extract-plugin
export default {"customswitch":"whitelistingSettings_customswitch__JSlc7"};